module.exports = __webpack_public_path__ + "img/art-school-icon3.002a0ed0.png";